import {
    alignmentSizes,
} from "./utils";

import {
    metaKey,
    cleanSearchText,
} from "../editor/utils";

import {
    Selector,
    zoomLevels,
} from "../mixins/dictionaries";

import {appendToast} from "../bootstrap";
import * as shortcuts from "../modules/shortcuts";

export default class Overview {
    constructor(settings, mediator) {
        this.settings = {};
        this.mediator = mediator

        this.initContainer();
        this.EventsOn();
    }

    initData(data) {
        this.settings.referenceLength = data.result.positions[data.result.reference.length - 1] + 1;

        this.positions = data.result.positions;

        this.referenceLength = data.result.reference.length
        this.sequenceLength = this.referenceLength;
        this.maxChromatogramValue = 0;
        this.maxQualityValue = 0;

        this.tempCountResultSearchRead = 0;

        this.successReads = 0;
        this.tempStartOffsetAlignment = 0;
        this.tempEndOffsetAlignment = 0;

        [this.sequenceLength, this.tempStartOffsetAlignment, this.tempEndOffsetAlignment, this.maxChromatogramValue, this.maxQualityValue, this.successReads] = alignmentSizes(this.referenceLength, data.result.reads);

        this.alignmentId = data.result.friendly_id;
        this.currentId = this.alignmentId;

        if (this.sequenceLength > this.referenceLength) {
            this.positions = [
                ...data.result.positions.slice(this.referenceLength - this.tempStartOffsetAlignment, this.referenceLength),
                ...this.positions,
                ...data.result.positions.slice(0, this.tempEndOffsetAlignment)
            ];
        }

        this.rangeBp = {
            start: 0,
            end: 0
        };

        this.previous = {}

        this.offsetScroll = {
            "current": 0
        };

        this.zoom = 12;
        this.fontHeight = 12;

        this.initElements();
        this.bindEvents();
        this.alignmentShortCuts();
    }

    initElements() {
        this.$totalBases.innerHTML = "<strong>" + this.settings.referenceLength + "</strong>";

        this.refreshSummary();
        this.resetSearch();
    }

    initContainer() {
        const $main = document.querySelector(Selector.OVERVIEW);
        this.$totalBases = $main.querySelector("#statusbar .total-length");
        this.$range = $main.querySelector(Selector.OVERVIEW + "  .range");

        this.$slider = $main.querySelector(Selector.OVERVIEW + "  #slide");
        this.$zoom = $main.querySelector(Selector.OVERVIEW + "  #zoom");

        this.$zoomButtons = $main.querySelectorAll(Selector.OVERVIEW + "  [data-editor-zoom]");
        this.$sliderButtons = $main.querySelectorAll(Selector.OVERVIEW + "  [data-editor-scroll]");

        this.$searchForm = $main.querySelector("form#searchbar");
        this.$txtToSearch = this.$searchForm.querySelector("#txtToSearch");
        this.$elementsFound = this.$searchForm.querySelector("#elementsFound");
        this.$goSearchButton = this.$searchForm.querySelector("#goSearch");
        this.$moveOnSearchButtons = this.$searchForm.querySelectorAll('.moveOnSearch');
        this.$resetSearchButton = this.$searchForm.querySelector("#reset");

        this.$rangeSelection = document.querySelector("#range");

        this.$selectAll = this.$rangeSelection.querySelector(".select-all");
        this.$copy = this.$rangeSelection.querySelector(".copy");

        this.$toastContainer = document.querySelector(Selector.TOASTS);

        this.userAgent = window.navigator.userAgent;
    }

    bindEvents() {
        this.$zoom.addEventListener("input", e => {
            this.EventsTrigger("setFontWidth", (24 - e.target.value))
            this.EventsTrigger("selectRange", this.rangeBp)
        })

        this.$slider.addEventListener("change", e => {
            this.offsetScroll.current = parseInt(e.target.value)
            this.EventsTrigger("setOffsetScroll", this.offsetScroll)
            this.EventsTrigger("slide", "end")
        })

        this.$zoomButtons.forEach(el => {
            el.addEventListener("click", () => {
                this.zoom += (parseInt(el.dataset.editorZoom) < 0 ? .5 : -.5);

                if (this.zoom >= zoomLevels.min && this.zoom <= zoomLevels.max) {
                    this.EventsTrigger("setFontWidth", this.zoom)
                    this.$zoom.value = 24 - this.zoom
                } else {
                    this.zoom = this.zoom < zoomLevels.min ? zoomLevels.min : zoomLevels.max;
                }
                this.EventsTrigger("selectRange", this.rangeBp)
            })
        })

        this.$sliderButtons.forEach(el => {
            el.addEventListener("click", () => {
                const min = 0
                const max = this.sequenceLength - this.maxBasePairsInAreaView;

                this.offsetScroll.current += parseInt(el.dataset.editorScroll);

                if (this.offsetScroll.current < min || this.offsetScroll.current > max) {
                    if (this.offsetScroll.current < min) {
                        this.offsetScroll.current = min
                    } else {
                        this.offsetScroll.current = max
                    }
                }

                this.EventsTrigger("setOffsetScroll", this.offsetScroll)
                this.EventsTrigger("slide", "end")
            })
        })

        this.$searchForm.addEventListener("submit", (e) => {
            e.preventDefault();
            this.search(this.$txtToSearch.value);
        });

        this.$goSearchButton.addEventListener("click", (e) => {
            e.preventDefault();
            this.search(this.$txtToSearch.value);
        });

        this.$moveOnSearchButtons.forEach(el => {
            el.addEventListener("click", e => {
                e.preventDefault();

                this.statusSearch.currentPosition += el.id === "right" ? 1 : -1;

                this.moveOnSearch(this.statusSearch.currentPosition);
            });
        })

        this.$resetSearchButton.addEventListener("click", (e) => {
            e.preventDefault();

            this.resetSearch();
            this.EventsTrigger("resetSearch")
        });

        this.$selectAll.addEventListener("click", (e) => {
            const $button = e.currentTarget;
            let rangeBp;
            if ($button.dataset.selection === "Select-all") {
                this.previous = {
                    start: this.rangeBp.start,
                    end: this.rangeBp.end
                }

                rangeBp = {
                    start: 0,
                    end: this.referenceLength,
                }

                $button.dataset.selection = "Deselect-all"
            } else {
                rangeBp = {
                    start: this.previous.start,
                    end: this.previous.end,
                }

                $button.dataset.selection = "Select-all"
            }

            this.selectRange(rangeBp);
            this.EventsTrigger("selectRange", rangeBp)
        })

        this.$copy.addEventListener("click", () => {
            this.EventsTrigger("copyBasePairsSelected", this.currentId)
        })
    }

    alignmentShortCuts() {
        const $body = document.querySelector("body");
        $body
            .addEventListener("keydown", e => {
                // copy by CMD|CTRL + C
                if (metaKey(e, this) && e.code === "c" && this.rangeBp.start !== this.rangeBp.end) {
                    this.EventsTrigger("copyBasePairsSelected", this.currentId)
                }
            })
    }

    /**
     * @param data = Object, rangeBp
     */
    selectRange(data) {
        this.rangeBp = {
            start: this.positions[data.start],
            end: this.positions[data.end] || this.referenceLength
        };

        this.rangeCommands();
        this.refreshSummary();
    }

    rangeCommands() {
        if (this.rangeBp.start !== this.rangeBp.end) {
            this.$rangeSelection.classList.remove("d-none")
        } else {
            this.$rangeSelection.classList.add("d-none")
        }
    }

    refreshSummary() {
        let start = this.rangeBp.start;
        let end = this.rangeBp.end;
        let summary;

        if (this.rangeBp.start !== this.rangeBp.end) {
            let totalSelectedBasePairLength = (end - start);

            if (end < start) {
                totalSelectedBasePairLength = (this.settings.referenceLength - start) + end;
            }

            summary = `
                <div>Selected:</div>
                <div class="range-length px-1"><strong>${totalSelectedBasePairLength || this.positions[this.referenceLength - 1]}</strong> bp</div>
                <div class="px-1">-</div>
                <div>from:</div>
                <div class="range-start px-1"><strong>${start + 1}</strong></div>
                <div>to:</div>
                <div class="range-end px-1"><strong>${end || this.settings.referenceLength - 1}</strong></div>
            `
        } else {
            summary = `
                <div>Cursor before bp: </div>
                <div class="px-1"><strong>${start + 1}</strong></div>                
            `
        }
        this.$range.innerHTML = summary
    }

    setData(data) {
        this.initData(data)
    }

    search(textToSearch) {
        this.initSearch();
        if (textToSearch.length > 0) {
            const cleanedSearchText = cleanSearchText(textToSearch);
            this.$txtToSearch.value = cleanedSearchText;
            if (cleanedSearchText.length) {
                this.statusSearch.textLength = cleanedSearchText.length
                this.EventsTrigger("search", {
                    "txtToSearch": cleanedSearchText
                })
            } else {
                this.resetSearch();
                this.EventsTrigger("resetSearch")
            }
        }
    }

    resultSearch(data) {
        this.tempCountResultSearchRead += 1;
        this.statusSearch.results = [...this.statusSearch.results, ...data.result];

        if (this.tempCountResultSearchRead === this.successReads + 1) {

            if (this.statusSearch.results.length) {
                this.statusSearch.length = this.statusSearch.results.length;
                this.statusSearch.currentPosition = 0;
                this.statusSearch.results.sort((a, b) => a.pos - b.pos);

                this.moveOnSearch(this.statusSearch.currentPosition);
            } else {
                appendToast(this.$toastContainer, "no items found", 1);
            }
        }
    }

    initSearch() {
        this.statusSearch = {
            textLength: 0,
            length: 0,
            currentPosition: -1,
            results: []
        }

        this.tempCountResultSearchRead = 0;
        this.$elementsFound.innerHTML = `0 of 0`;
    }

    resetSearch() {
        this.initSearch();
        this.$txtToSearch.value = "";
    }


    moveOnSearch(position) {
        if (position >= 0 && position < this.statusSearch.length) {
            this.statusSearch.currentPosition = position
            this.$elementsFound.innerHTML = `${position + 1} of ${this.statusSearch.length}`;

            const min = 0
            const max = this.sequenceLength - this.maxBasePairsInAreaView;

            this.offsetScroll.current = Math.round(this.statusSearch.results[position].pos - (this.maxBasePairsInAreaView / 2));

            if (this.offsetScroll.current < min || this.offsetScroll.current > max) {
                if (this.offsetScroll.current < min) {
                    this.offsetScroll.current = min
                } else {
                    this.offsetScroll.current = max
                }
            }

            const rangeBp = {
                start: this.statusSearch.results[position].pos,
                end: this.statusSearch.results[position].pos + this.statusSearch.textLength
            };

            this.selectRange(rangeBp)
            this.setCurrentID(this.statusSearch.results[position].id)

            this.$slider.value = this.offsetScroll.current

            this.EventsTrigger("setOffsetScroll", this.offsetScroll)
            this.EventsTrigger("slide", "end")

            this.EventsTrigger("moveOnSearchResult", {
                rangeBp: rangeBp,
                id: this.currentId
            })
        } else {
            this.statusSearch.currentPosition = this.statusSearch.currentPosition ? this.statusSearch.length : -1;
        }
    }

    setMaxScroll(data) {
        this.maxBasePairsInAreaView = data.width;
        this.$slider.max = this.sequenceLength - data.width;
    }

    setScroll(data) {

        this.offsetScroll.current += data * -1;
        this.$slider.value = this.offsetScroll.current
    }

    setOffsetScroll(data) {
        if (this.zoom !== zoomLevels.max) {
            this.offsetScroll.current = data.current
            this.$slider.value = this.offsetScroll.current
        }
    }

    setFontWidth(data) {
        this.zoom = data;
        this.$zoom.value = (24 - data)
    }

    basePairsToCopy(data) {
        const $toastContainer = document.querySelector(Selector.TOASTS);
        shortcuts.copy($toastContainer, data);
    }

    setCurrentID(data = this.alignmentId) {
        this.currentId = data;
    }

    EventsTrigger(action, data) {
        if (this.mediator) {
            this.mediator.trigger(action, data, this)
        }
    }

    EventsOn() {
        if (this.mediator) {
            this.mediator.on("setData", "setData", this);
            this.mediator.on("selectRange", "selectRange", this);
            this.mediator.on("setAreaView", "setMaxScroll", this);

            this.mediator.on("setFontWidth", "setFontWidth", this);

            this.mediator.on("setScroll", "setScroll", this);
            this.mediator.on("setOffsetScroll", "setOffsetScroll", this);

            this.mediator.on("resultSearch", "resultSearch", this);
            this.mediator.on("basePairsToCopy", "basePairsToCopy", this)

            this.mediator.on("currentID", "setCurrentID", this)
        }
    }
}